import { IFilterAttributes, IFilters } from '@types';
import { useState } from 'react';

import { PrismicRichText } from '@prismicio/react';

// import { useMediaQuery } from '@hooks/useMediaQuery';
// import { smallScreen } from '@styles/constants';

import { useScrolled } from '@hooks';

import { ProductCardFragment } from '@sdk/gqlTypes/generatedOperations';
// import { RudderAnalytics } from '../../app/analitics';

// import { Button } from '@components/atoms/Button';
import { ProductList } from '@components/organisms/ProductList';
import { FilterSidebar } from '@components/organisms/FilterSidebar';

import {
  CategoryHeaderFragment,
  CategoryBannerFragment,
} from '@prismic/gqlTypes/prismicOperations';

import { FilterButton } from '@components/molecules/FilterButton';

import * as S from './styles';

interface PageProps {
  header: CategoryHeaderFragment | null;
  activeFilters: number;
  attributes: IFilterAttributes[];
  displayLoader: boolean;
  filters: IFilters;
  hasNextPage: boolean;
  products: ProductCardFragment[] | null;
  benefits: CategoryBannerFragment[] | null;
  clearFilters: () => void;
  onLoadMore: () => void;
  onFiltersChange: (attributeSlug: string, value: string) => void;
}

const Page: React.FC<PageProps> = ({
  header,
  activeFilters,
  attributes,
  displayLoader,
  hasNextPage,
  clearFilters,
  onLoadMore,
  products,
  benefits,
  filters,
  onFiltersChange,
}) => {
  const [isScrolledTop, isScrolledToBottom] = useScrolled(200, 600);
  const [showFilters, setShowFilters] = useState(false);
  // const [isSmallScreen] = useMediaQuery(`(max-width: ${smallScreen}px)`);

  return (
    <S.Wrapper className="category-page">
      <S.Header>
        <S.Title>
          <PrismicRichText field={header.name} />
        </S.Title>
        <S.Excerpt>
          <PrismicRichText field={header.excerpt} />
        </S.Excerpt>
      </S.Header>
      <S.Content>
        <S.Filters>
          <FilterSidebar
            show={showFilters}
            hide={() => setShowFilters(false)}
            onFiltersChange={onFiltersChange}
            attributes={attributes}
            filters={filters}
            clearFilters={clearFilters}
            activeFilters={activeFilters}
          />
        </S.Filters>
        <S.ProductList>
          <ProductList
            products={products}
            canLoadMore={hasNextPage}
            loading={displayLoader}
            onLoadMore={onLoadMore}
            benefits={benefits}
          />
        </S.ProductList>
      </S.Content>
      <FilterButton
        onSubmit={() => setShowFilters((state) => !state)}
        isScrolledToBottom={!isScrolledTop || isScrolledToBottom}
      />
    </S.Wrapper>
  );
};

Page.displayName = 'CategoryPage';

export default Page;
